module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-checker"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" " + _vm._s(_vm.i18n.title))]), _vm._v(" "), _c('p', {
    staticClass: "introduction"
  }, [_vm._v(_vm._s(_vm.i18n.description))]), _vm._v(" "), _c('div', {
    staticClass: "overall-status"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.completed),
      expression: "!completed"
    }],
    staticClass: "in-progress"
  }, [_vm._v(_vm._s(_vm.i18n.checking))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.completed),
      expression: "!completed"
    }],
    ref: "statusIndicator"
  }), _vm._v(" "), _c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }]
  }, [_vm._v(_vm._s(_vm.i18n.complete))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.completed),
      expression: "completed"
    }],
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-download",
    attrs: {
      "target": "_blank",
      "href": _vm.downloadUrl
    }
  }, [_vm._v(_vm._s(_vm.i18n.downloadCSV))])])])])]), _vm._v(" "), _c('connection-speed', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('popup-blocker', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('cookie-enabled', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('screen-resolution', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('browser-size', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('web-browser', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('operation-system', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('cdn-access', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('real-time-server-access', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('api-connection-checker', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  }), _vm._v(" "), _c('video-player', {
    on: {
      "initialized": _vm.registerChecker,
      "completed": _vm.completeChecker
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11a156e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SystemChecker.vue
// module id = 285
// module chunks = 2